function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.47075 7.47L3.75075 8.19V1H2.25075V8.189L1.53075 7.469C1.23775 7.176 0.76275 7.176 0.46975 7.469C0.17675 7.762 0.17675 8.237 0.46975 8.53L2.99975 11.06L5.52975 8.53C5.82275 8.237 5.82275 7.762 5.52975 7.469C5.23675 7.176 4.76375 7.177 4.47075 7.47ZM11.5308 7.47C11.2378 7.177 10.7628 7.177 10.4698 7.47L9.74975 8.19V1H8.24975V8.189L7.52975 7.469C7.23675 7.176 6.76175 7.176 6.46875 7.469C6.17575 7.762 6.17575 8.237 6.46875 8.53L8.99875 11.06L11.5288 8.53C11.8238 8.237 11.8238 7.763 11.5308 7.47Z",
  fill: "#484A57"
});

function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.185b10df.svg";
export { ForwardRef as ReactComponent };